var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4068_36608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9258 4.07501L16.355 6.63418L13.355 3.64834L15.925 1.08918C15.3125 0.914792 14.6784 0.828646 14.0416 0.833343C12.8538 0.935412 11.7496 1.48631 10.9536 2.37388C10.1577 3.26145 9.72997 4.41899 9.75745 5.61084C9.75174 6.07843 9.83928 6.54247 10.015 6.97584L1.78912 14.2258C1.50394 14.4803 1.27275 14.7895 1.10924 15.1349C0.945731 15.4804 0.853232 15.8552 0.837223 16.237C0.821214 16.6189 0.882023 17.0001 1.01604 17.3581C1.15007 17.716 1.35458 18.0434 1.61745 18.3208C1.8868 18.6021 2.21296 18.8228 2.57422 18.9683C2.93549 19.1138 3.32359 19.1806 3.7127 19.1645C4.10182 19.1483 4.48304 19.0495 4.831 18.8746C5.17896 18.6997 5.48569 18.4527 5.73079 18.15L13.0133 9.96084C13.7916 10.1888 14.6101 10.2456 15.4125 10.1275C16.2581 9.95255 17.0401 9.55037 17.6742 8.96422C18.3084 8.37807 18.7708 7.63013 19.0116 6.80084C19.2406 5.90232 19.2109 4.95735 18.9258 4.07501Z",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4068_36608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.8ee552d953b982882cd17da87ce9096f.svg";
export { ForwardRef as ReactComponent };